import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../i18n/locales/en/translation.json';
import ruTranslation from '../i18n/locales/ru/translation.json';
import enTranslate from '../i18n/locales/en/translate.json';
import ruTranslate from '../i18n/locales/ru/translate.json';
import enLanding from '../i18n/locales/en/landing.json';
import ruLanding from '../i18n/locales/ru/landing.json';

const resources = {
  en: {
    translation: enTranslation,
    testItems: enTranslate.testItems,
    landing: enLanding
  },
  ru: {
    translation: ruTranslation,
    testItems: ruTranslate.testItems,
    landing: ruLanding
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'ru',
    fallbackLng: 'ru',
    ns: ['translation', 'testItems', 'landing'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    },
  });

export default i18n; 